import React, { useRef } from "react";
import API from "../../../../services/api";
import getImageUrl from "../../../../utils/imageUrl";

import {
    Camera,
    Trash2
} from "lucide-react";

import "./ProfilePhoto.css";

function ProfilePhoto({
    profile,
    setProfile,
}) {

    const fileInputRef = useRef(null);

    const handleUpload = async (event) => {

        try {

            const file = event.target.files[0];

            if (!file) return;

            const formData = new FormData();

            formData.append("profileImage", file);

            const response = await API.post(
                "/delivery/profile/photo",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.data.success) {

                setProfile({
                    ...profile,
                    profileImage:
                        response.data.profileImage,
                });

            }

        } catch (error) {

            console.error(
                "Profile photo upload error:",
                error
            );

        } finally {

            // Allow selecting the same image again
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }

        }

    };


    const removePhoto = async () => {

        try {

            const response = await API.delete(
                "/delivery/profile/photo"
            );

            if (response.data.success) {

                setProfile({
                    ...profile,
                    profileImage: "",
                });

            }

        } catch (error) {

            console.error(
                "Remove profile photo error:",
                error
            );

        }

    };


    const profileImage = profile?.profileImage
        ? getImageUrl(
            profile.profileImage.includes("/uploads/")
                ? profile.profileImage
                : `uploads/delivery/${profile.profileImage}`
        )
        : "/images/default-profile.png";


    return (

        <div className="edit-photo-card">

            <div className="photo-wrapper">

                <img
                    src={profileImage}
                    alt="Profile"
                    className="edit-profile-image"
                    onError={(event) => {
                        event.currentTarget.src =
                            "/images/default-profile.png";
                    }}
                />

                <button
                    type="button"
                    className="camera-button"
                    onClick={() =>
                        fileInputRef.current?.click()
                    }
                >
                    <Camera size={18} />
                </button>

            </div>


            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleUpload}
            />


            {profile?.profileImage && (

                <button
                    type="button"
                    className="remove-photo"
                    onClick={removePhoto}
                >
                    <Trash2 size={18} />
                    Remove Photo
                </button>

            )}

        </div>

    );

}

export default ProfilePhoto;